import React from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';

import { MAX_SUBSCRIPTION_USER } from '@/constants';
import { isEMBA } from '@/types/subscriptions/subscription';
import { MAX_SUBSCRIPTION_USER_PAGE } from '@/settings/pages';
import { Label } from '@/components/shared/Label';

type Props = {
  error?: string;
  serviceGroupId: number | null;
};

export const UpperLimitUser: React.FC<Props> = ({ error, serviceGroupId }) => (
  <Styled>
    {(() => {
      if (!error || !serviceGroupId) {
        return null;
      }

      const key = isEMBA(serviceGroupId) ? 'emba' : 'hodai';
      return (
        <Label>
          <p>
            <Trans
              i18nKey={`ui.subscription.error.maximumNumberUsers.${key}`}
              values={{ number: MAX_SUBSCRIPTION_USER }}
            >
              <br />
              <a
                href={MAX_SUBSCRIPTION_USER_PAGE}
                rel="noopener noreferrer"
                target="_blank"
              >
                link
              </a>
            </Trans>
          </p>
        </Label>
      );
    })()}
  </Styled>
);

const Styled = styled.div`
  margin-bottom: 3em;

  p {
    line-height: 1.5em;

    a {
      color: #9f3a38 !important;
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }
  }
`;
